import React from 'react';
import './Loading.scss';

const Loading = ({ message }) => (
  <div className="loading">
    <div className="loading-container">
      <div className="processing">{message}</div>
      <div className="loader"></div>
    </div>

    <div className="background-modal"></div>
  </div>
);

export default Loading;
